/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UpdateAccountStringOptionRequest model module.
 * @module model/UpdateAccountStringOptionRequest
 * @version V1
 */
class UpdateAccountStringOptionRequest {
    /**
     * Constructs a new <code>UpdateAccountStringOptionRequest</code>.
     * @alias module:model/UpdateAccountStringOptionRequest
     */
    constructor() { 
        
        UpdateAccountStringOptionRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UpdateAccountStringOptionRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UpdateAccountStringOptionRequest} obj Optional instance to populate.
     * @return {module:model/UpdateAccountStringOptionRequest} The populated <code>UpdateAccountStringOptionRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateAccountStringOptionRequest();

            if (data.hasOwnProperty('option')) {
                obj['option'] = ApiClient.convertToType(data['option'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UpdateAccountStringOptionRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdateAccountStringOptionRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['option'] && !(typeof data['option'] === 'string' || data['option'] instanceof String)) {
            throw new Error("Expected the field `option` to be a primitive type in the JSON string but got " + data['option']);
        }
        // ensure the json data is a string
        if (data['value'] && !(typeof data['value'] === 'string' || data['value'] instanceof String)) {
            throw new Error("Expected the field `value` to be a primitive type in the JSON string but got " + data['value']);
        }

        return true;
    }


}



/**
 * @member {String} option
 */
UpdateAccountStringOptionRequest.prototype['option'] = undefined;

/**
 * @member {String} value
 */
UpdateAccountStringOptionRequest.prototype['value'] = undefined;






export default UpdateAccountStringOptionRequest;

